var shared = require('../internals/shared');
var uid = require('../internals/uid');

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/shared-key.js